import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { CheckIcon, CloneIcon } from './Icons';
import copy from 'copy-to-clipboard';
import _, { map } from 'lodash';
import classnames from 'classnames';
import parseHtml from 'utils/parserUtil';
// import { Switch } from 'antd';
import hljs from 'highlight.js';
import 'less/components/hljs-light.less'

export default function CodeSnippet({ text, node = undefined, language, className = undefined, theme = 'light' }) {
    const [codeText, setCodeText] = useState('');

    const code = useMemo(() => {
        if(hljs && text){
            try {
                const highlightedCode = language
                    ? hljs.highlight(text, { language }).value
                    : hljs.highlightAuto(text).value;
                const div = document.createElement('div');
                div.innerHTML = highlightedCode;
                [].forEach.call(div.querySelectorAll('span.hljs-deletion, span.hljs-addition'), (span) => {
                    const classList = span.previousElementSibling?.classList;
                    if(classList && (classList.contains('hljs-deletion') || classList.contains('hljs-addition'))){
                        div.insertBefore(document.createElement('br'), span);
                    }
                })
                return div.innerHTML;
            } catch (e) {
                console.log('Unable to highlight code snippet.', e)
            }
        }
        return text;
    }, [text, language])
    // language is intentionally excluded: re-rendering on text change is sufficient
    // because the DOM (ref.current.innerText) already reflects the updated highlight
    // output by the time this effect runs.
    useEffect(() => {
        if(ref.current){
            setCodeText(ref.current.innerText)
        }
    }, [text]);
    const ref = useRef();
    return (
        <pre className={classnames('code-snippet', `hljs-${theme}`, className)}>
            <div className="code-wrapper">
                <code className="hljs" ref={ref}>
                    {_.size(node?.children) > 1 ? node.children.map(extractText) : parseHtml(code)}
                </code>
            </div>
            <CopyButton text={codeText} />
        </pre>
    )
}

function extractText(node){
    if(node.type === 'text'){
        return node.data;
    }
    if(node.children?.length > 0){
        return map(node.children, extractText)
    }
    return '';
}

function CopyButton({ text }) {
    const [copied, setCopied] = useState(false);

    const copyCode = useCallback(() => {
        copy(text || '');
        setCopied(true);
    }, [text]);

    useEffect(() => {
        if(copied){
            const timeoutId = setTimeout(setCopied, 2000, false);
            return () => clearTimeout(timeoutId);
        }
    }, [copied])

    if(copied){
        return <span className="copy-btn"><CheckIcon className="success" /> copied</span>
    }
    return (
        <button type="button" className="copy-btn" onClick={copyCode}><CloneIcon /> copy</button>
    )
}

export function transformLookForCodeSnippet(node, index){
    if (node.type === 'tag' && node.name === 'pre') {
        let data = '';
        const child = node.children?.[0];
        if(child){
            if(child.type === 'tag'){
                data = child.children?.[0]?.data;
            } else {
                data = child.data || '';
            }
        }
        return <CodeSnippet key={index} text={data} node={node} language={node.attribs['data-language']} />;
    }
}
